import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 33"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.164 17.228c0-3.051 0-4.577.692-5.841.693-1.265 1.957-2.05 4.487-3.62l2.666-1.655c2.674-1.66 4.011-2.489 5.488-2.489s2.814.83 5.488 2.49l2.667 1.654c2.53 1.57 3.794 2.355 4.486 3.62.693 1.264.693 2.79.693 5.841v2.028c0 5.201 0 7.802-1.562 9.418s-4.077 1.616-9.105 1.616h-5.333c-5.029 0-7.543 0-9.105-1.616s-1.562-4.216-1.562-9.418z",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.5 23.957a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z"
    }, null, -1)
  ])))
}
export default { render: render }